module.exports = __webpack_public_path__ + "img/Porto Apartment - 40 of 85.61b1854b.jpeg";